import * as React from 'react';
import { useFormikContext } from 'formik';

import { Checkbox, Title } from '@/shared/ui/elements';

import NoPreferenceButton from './NoPreferenceButton';

import {
  CheckBoxContainer,
  CheckboxList,
  ButtonContainer,
} from '../ShiftPreferencesModal.styled';
import NextButton from './NextButton';

const options = [
  {
    value: 'vaccination',
    label: (
      <div>
        <h4>Limited-Service Clinic</h4>
        <p>Wellness care work inside a vaccine clinic.</p>
      </div>
    ),
  },
  {
    value: 'wellness',
    label: (
      <div>
        <h4>Limited-Service Hospital</h4>
        <p>Wellness care work inside a hospital.</p>
      </div>
    ),
  },
  {
    value: 'hospital',
    label: (
      <div>
        <h4>Full-Service Hospital</h4>
        <p>Relief work inside a full service hospital.</p>
      </div>
    ),
  },
];

export const SelectTypes = ({ slick, forEdit }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <div>
      <Title>What shift type(s) do you prefer?</Title>

      <CheckboxList columns={1} gap={16}>
        {options.map((option) => {
          const name = `shiftTypes__${option.value}`;
          return (
            <CheckBoxContainer key={option.value} align="flex-start">
              <Checkbox
                label={option.label}
                role="checkbox"
                type="checkbox"
                name={name}
                onChange={(event) => setFieldValue(name, event.target.checked)}
              />
            </CheckBoxContainer>
          );
        })}
      </CheckboxList>

      <ButtonContainer>
        <NextButton forEdit={forEdit} slick={slick} />
        {!forEdit && (
          <NoPreferenceButton
            afterOnClick={() => slick.current?.slickNext()}
            options={options}
            field="shiftTypes"
          />
        )}
      </ButtonContainer>
    </div>
  );
};
